import type { ReactTable } from '@/lib/tanstack-table';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import type { useLineGroupTable } from './lineGroupTable';

/** Rendered row order after TanStack sort, minus rows hidden by collapsed groups. */
export function assignmentVisibleLineIds(
  table: ReactTable<AssignmentLine>,
  groupProps: ReturnType<typeof useLineGroupTable>['groupProps'],
): string[] {
  const { isRowHidden } = groupProps(table);
  return table
    .getRowModel()
    .rows.flatMap((row) =>
      isRowHidden?.(row) ? [] : [row.original.suggestionId],
    );
}
